import * as React from 'react';
import {Person} from '@models/person';
import {Divider, Modal, Table, Button, Avatar} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import Message from "@constants/message";
import {PaginationDefaultParams} from "../custom/Paginator";
import TextWithTooltip from "../custom/TextWithTooltip";
import {NavLink} from "react-router-dom";


type Props = {
  data: Person[],
  loading: boolean,
  deleteFn: (item: Person) => void;
  intl: intlShape.isRequired
  currentPage: number
};


const PeopleTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const deleteTag = (item: Person): void => {
    Modal.confirm({
      content: formatMessage({
        id: "app.general_delete_warning",
        defaultMessage: Message.Warning.Delete,
      }),
      okText: formatMessage({
        id: "app.delete",
        defaultMessage: "Delete",
      }),
      cancelText: formatMessage({
        id: "app.cancel",
        defaultMessage: "Cancel",
      }),
      className: "delete-confirm-dialog",
      onOk: () => deleteFn(item),
    });
  };
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: 'index',
      key: 'id',
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      dataIndex: 'avatar_image',
      key: 'avatar_image',
      render: (a, record) => <Avatar shape="circle"
                                     size="small"
                                     src={record.avatar_image ? record.avatar_image.path : null}
                                     icon="user"/>
    },
    {
      title: <FormattedMessage id="app.name" defaultMessage={`Name`}/>,
      width: 150,
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: <FormattedMessage id="app.english_name" defaultMessage={`English Name`}/>,
      width: 100,
      dataIndex: 'name_en',
      key: 'name_en',
    },
    {
      title: <FormattedMessage id="app.summary" defaultMessage={`Summary`}/>,
      width: 200,
      dataIndex: 'summary',
      key: 'summary',
      render: (text) => <TextWithTooltip text={text || ""}/>
    },
    {
      title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
      width: 120,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text, record) => <FormattedDateTime date={text}/>
    },
    {
      title: '',
      key: 'actions',
      width: 90,
      dataIndex: 'actions',
      render: (text, record) => (
        <span>
          <NavLink to={`/people/${record.id}/edit`}>
             <Button type="link" size={`small`}>
                <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
              </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button type="link" className={`danger`} onClick={() => deleteTag(record)}>
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
      ),
    },
  ];
  
  
  return (
    <Table columns={columns}
           loading={loading}
           pagination={false}
           dataSource={data}
           rowKey='id'/>
  )
};

export default injectIntl(PeopleTable);